import { motion } from "framer-motion";
import { ClipboardList, Search, Map, Rocket } from "lucide-react";

const chapters = [
  {
    number: "01",
    icon: ClipboardList,
    title: "Ön Analiz Talebi",
    description: "7 soruluk kurumsal formumuz üzerinden firmanızın temel verilerini ve dijital ihtiyaçlarını iletin.",
  },
  {
    number: "02",
    icon: Search,
    title: "Derinlemesine İnceleme",
    description: "Uzman ekibimiz sektörünüzü, dijital varlığınızı ve operasyonel süreçlerinizi 24 saat içinde analiz eder.",
  },
  {
    number: "03",
    icon: Map,
    title: "Stratejik Yol Haritası",
    description: "Size özel hazırlanan 'KOBİ Dijital Sağlık Raporu' ve özel teşvik/yazılım önerileri sunulur.",
  },
  {
    number: "04",
    icon: Rocket,
    title: "Aksiyon & Sürekli Büyüme",
    description: "Belirlenen öncelikli dijital projeleriniz için hayata geçirme aşamasında birebir rehberlik sağlanır.",
  },
];

export default function Chapters() {
  return (
    <section id="surec" className="py-16 sm:py-24 lg:py-32" data-testid="chapters-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#0000FF] font-semibold">Süreç Nasıl Çalışır?</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0F172A] mt-4">
            Dört Adımda Dijital Dönüşümünüzü Planlayalım
          </h2>
          <p className="text-base leading-relaxed text-[#475569] mt-4">
            Şeffaf, hızlı ve tamamen ücretsiz. Başvurunuzdan yol haritanıza kadar her adım net.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mt-12 lg:mt-16">
          {chapters.map((chapter, i) => (
            <motion.div
              key={chapter.number}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -6 }}
              className="group relative bg-white rounded-2xl border border-[#E2E8F0] p-6 sm:p-8 transition-shadow hover:shadow-xl hover:shadow-[#0000FF]/5 hover:border-[#93C5FD]"
              data-testid={`chapter-${chapter.number}`}
            >
              <span className="font-display text-5xl font-extrabold text-[#0000FF]/10 group-hover:text-[#0000FF]/20 transition-colors">
                {chapter.number}
              </span>
              <div className="mt-6 w-11 h-11 rounded-xl bg-[#0000FF]/5 border border-[#0000FF]/10 grid place-items-center text-[#0000FF]">
                <chapter.icon size={20} />
              </div>
              <h3 className="font-display text-lg sm:text-xl font-semibold text-[#0F172A] mt-5">{chapter.title}</h3>
              <p className="text-sm leading-relaxed text-[#475569] mt-3">{chapter.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
